// 申请单路由
export default {
  path: "/applicationForm",
  name: "applicationForm",
  roles: ["warehouseSupervisor", "warehouseManager"],
  meta: { title: "申请单", icon: "applicationForm" },
  children: [
    {
      path: "/applicationForm/application",
      name: "application",
      roles: ["warehouseSupervisor", "warehouseManager"],
      component: () =>
        import(
          /* webpackChunkName: "application" */ "@/views/warehouse/applicationForm/application"
        ),
      meta: { title: "申请", icon: "apply" },
    },
    {
      path: "/applicationForm/updateApplication",
      name: "updateApplication",
      roles: ["warehouseSupervisor", "warehouseManager"],
      component: () =>
        import(
          /* webpackChunkName: "updateApplication" */ "@/views/warehouse/applicationForm/updateApplication"
        ),
      meta: {
        title: "修改申请",
        icon: "product",
        sidebar: false,
        noCache: true,
      },
    },
    {
      path: "/applicationForm/approval",
      name: "approval",
      roles: ["warehouseManager"],
      component: () =>
        import(
          /* webpackChunkName: "approval" */ "@/views/warehouse/applicationForm/approval"
        ),
      meta: { title: "审批", icon: "approval", noCache: true },
    },
    {
      path: "/applicationForm/applicationRecord",
      name: "applicationRecord",
      roles: ["warehouseSupervisor", "warehouseManager"],
      component: () =>
        import(
          /* webpackChunkName: "applicationRecord" */ "@/views/warehouse/applicationForm/applicationRecord"
        ),
      meta: { title: "申请记录", icon: "apply-record", noCache: true },
    },
  ],
};
